export const useAutomationEvents = () => {
  const getAutomationEvents = async (automationId: string) => {
    try {
      const response = await $fetch(`/api/v1/automation/${automationId}/events`, {
        method: 'GET',
      })
      return { data: response.data, error: null }
    } catch (error) {
      console.error('Error fetching automation events:', error)
      return { data: null, error }
    }
  }

  const getEventStepStatus = (status: string) => {
    const statusMap: Record<string, { label: string, severity: string, icon: string }> = {
      PENDING: { label: 'Pending', severity: 'warn', icon: 'mdi:clock-outline' },
      IN_PROGRESS: { label: 'In Progress', severity: 'warn', icon: 'mdi:progress-clock' },
      COMPLETED: { label: 'Completed', severity: 'success', icon: 'mdi:check-circle' },
      FAILED: { label: 'Failed', severity: 'danger', icon: 'mdi:close-circle' },
    }
    return statusMap[status] || { label: 'Unknown', severity: 'secondary', icon: 'mdi:help-circle' }
  }

  const getStepTypeLabel = (stepType: string) => {
    const typeMap: Record<string, { label: string, icon: string }> = {
      SEND_EMAIL: { label: 'Send Email', icon: 'mdi:email' },
      SEND_SMS: { label: 'Send SMS', icon: 'mdi:message' },
      WAIT: { label: 'Wait', icon: 'mdi:timer' },
      CREATE_TASK: { label: 'Create Task', icon: 'mdi:check-circle' },
      CREATE_NOTE: { label: 'Create Note', icon: 'mdi:note' },
      CONDITION: { label: 'Condition', icon: 'mdi:filter' },
    }
    return typeMap[stepType] || { label: stepType, icon: 'mdi:help-circle' }
  }

   const updateAutomationEventStep = async (automationEventStepId: string, body:any) => {
    try {
      const response = await $fetch(`/api/v1/automation-event/${automationEventStepId}`, {
        method: 'PUT',
        body: body
      })
      return { data: response.data, error: null }
    } catch (error) {
      console.error('Error fetching automation events:', error)
      return { data: null, error }
    }
  }

  const retryEvent = async (automationId: string, eventId: string) => {
    await $fetch(`/api/v1/automation/${automationId}/events/${eventId}/retry`, {
      method: 'POST',
    })
  }

  const cancelEvent = async (automationId: string, eventId: string) => {
    await $fetch(`/api/v1/automation/${automationId}/events/${eventId}/cancel`, {
      method: 'POST',
    })
  }

  const resolveEvent = async (automationId: string, eventId: string) => {
    await $fetch(`/api/v1/automation/${automationId}/events/${eventId}/resolve`, {
      method: 'POST',
    })
  }

  const cancelEventsByContactAndBusinessId = async (
    contactId: string, 
    businessId: string
  ) => {
    try {
      const response = await $fetch(`/api/v1/automation-event/cancel-active-events`, {
        method: 'POST',
        body: { contactId, businessId },
      })
      return { data: response.data, error: null }
    } catch (error) {
      console.error('Error cancelling active automation events:', error)
      return { data: null, error }
    }
  }

  return {
    updateAutomationEventStep,
    getAutomationEvents,
    getEventStepStatus,
    getStepTypeLabel,
    retryEvent,
    cancelEvent,
    resolveEvent,
    cancelEventsByContactAndBusinessId
  }
}
